var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0664 18.0312C42.5508 16.918 43.8867 15.582 44.9258 14.0234C43.5898 14.6172 42.0312 15.0625 40.4727 15.2109C42.1055 14.2461 43.293 12.7617 43.8867 10.9062C42.4023 11.7969 40.6953 12.4648 38.9883 12.8359C37.5039 11.2773 35.5 10.3867 33.2734 10.3867C28.9688 10.3867 25.4805 13.875 25.4805 18.1797C25.4805 18.7734 25.5547 19.3672 25.7031 19.9609C19.2461 19.5898 13.457 16.4727 9.59766 11.7969C8.92969 12.9102 8.55859 14.2461 8.55859 15.7305C8.55859 18.4023 9.89453 20.7773 12.0469 22.1875C10.7852 22.1133 9.52344 21.8164 8.48438 21.2227V21.2969C8.48438 25.082 11.1562 28.1992 14.7188 28.9414C14.125 29.0898 13.3828 29.2383 12.7148 29.2383C12.1953 29.2383 11.75 29.1641 11.2305 29.0898C12.1953 32.207 15.0898 34.4336 18.5039 34.5078C15.832 36.5859 12.4922 37.8477 8.85547 37.8477C8.1875 37.8477 7.59375 37.7734 7 37.6992C10.4141 39.9258 14.4961 41.1875 18.9492 41.1875C33.2734 41.1875 41.0664 29.3867 41.0664 19.0703C41.0664 18.6992 41.0664 18.4023 41.0664 18.0312Z",
    fill: "#1B90EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -1.45518,
    y: -0.291035,
    width: 54.9104,
    height: 54.9104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727588
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.101961 0 0 0 0 0.466667 0 0 0 0.0337375 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.9aac69098400e3f61defbf485b5440c7.svg";
export { ForwardRef as ReactComponent };